'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _container = require('@hixme-ui/container');

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = function Card(props) {
  return _react2.default.createElement(_container2.default, props);
};

Card.displayName = 'hui:Card';
Card.huiName = 'Card';

Card.defaultProps = {
  rounded: true,
  shadow: true,
  white: true
};

exports.default = Card;
//# sourceMappingURL=Card.js.map


//////////////////
// WEBPACK FOOTER
// ../card/lib/Card.js
// module id = 677
// module chunks = 0